import { CourseSearchSortOrder } from '../../interfaces/CoursesInterface';
import { findFilterField } from './courseMappingFilterFields';

export type CourseMappingSortOrder = CourseSearchSortOrder;

export interface CourseMappingSortState {
  key: string;
  order: CourseMappingSortOrder;
}

export const buildCourseSortParams = (
  sort: CourseMappingSortState | null
): { sort_by: string; order: CourseMappingSortOrder } | Record<string, never> => {
  if (!sort) {
    return {};
  }

  const field = findFilterField(sort.key);
  if (!field) {
    return {};
  }

  return { sort_by: field.param, order: sort.order };
};

export const serializeSortParams = (sort: CourseMappingSortState | null): string =>
  JSON.stringify(buildCourseSortParams(sort));
